import { NgModule } from '@angular/core';
// Per incorporare componenti angular
import { CommonModule } from '@angular/common';
// Per incorporare componenti ionic
import { IonicModule } from '@ionic/angular';
// Per poter usare la translate pipe nei componenti
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CenteredSpinnerComponent } from './centered-spinner/centered-spinner.component';
import { BottomFooterButtonsComponent } from './bottom-footer-buttons/bottom-footer-buttons.component';
import { FooterButtonComponent } from './footer-button/footer-button.component';
import { LabeledFabButtonEntryComponent } from './labeled-fab-button-entry/labeled-fab-button-entry.component';
import { OverlayHeaderComponent } from './overlay-header/overlay-header.component';
import { HeaderInterventoComponent } from './header-intervento/header-intervento.component';
import { PopoverInterventoComponent } from './popover-intervento/popover-intervento.component';
import { PopoverDataComponent } from 'src/app/interventi/popover-data/popover-data.component';
import { PopoverInterventoAutomezziComponent } from './popover-intervento-automezzi/popover-intervento-automezzi.component';

// Tutorial https://angularfirebase.com/snippets/how-manage-shared-components-in-an-ionic-4-app/
@NgModule({
  imports: [
    // Dipendenze necessarie
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  // Componenti condivisi vanno aggiunti sia in declaration che export
  declarations: [
    HeaderComponent,
    OverlayHeaderComponent,
    CenteredSpinnerComponent,
    FooterButtonComponent,
    BottomFooterButtonsComponent,
    LabeledFabButtonEntryComponent,
    HeaderInterventoComponent,
    PopoverInterventoComponent,
    PopoverDataComponent,
    PopoverInterventoAutomezziComponent
  ],
  // Resi visibile esternamente
  exports: [
    HeaderComponent,
    OverlayHeaderComponent,
    HeaderInterventoComponent,
    CenteredSpinnerComponent,
    FooterButtonComponent,
    BottomFooterButtonsComponent,
    LabeledFabButtonEntryComponent,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SharedComponentsModule { }
